export type AuthedScreen =
  | 'org_selection'
  | 'mfa'
  | 'firm_onboarding'
  | 'card_pending_member'
  | 'profile_onboarding'
  | 'locked'
  | 'app';

export interface AppGateInput {
  needsOrgSelection: boolean;
  mfaBlocked: boolean;
  needsFirmOnboarding: boolean;
  /** The firm has no saved card and the server blocks everything else, but this person cannot add one. */
  cardPendingForMember: boolean;
  needsProfileOnboarding: boolean;
  firmLocked: boolean;
}

/**
 * Which screen a signed-in person sees, first match wins. The order is deliberate:
 *   1. choose a firm, 2. MFA, 3. the firm setup flow (card), 4. the profile questionnaire, 5. lockout, 6. the app.
 * MFA is before the card step because the server's MFA gate covers /api/onboarding and /api/billing, so an owner
 * cannot reach the card step without a verified session, and an owner or admin must not attach a payment method
 * to a firm from a session that has not passed MFA.
 */
export function resolveAuthedScreen(input: AppGateInput): AuthedScreen {
  if (input.needsOrgSelection) return 'org_selection';
  if (input.mfaBlocked) return 'mfa';
  if (input.needsFirmOnboarding) return 'firm_onboarding';
  if (input.cardPendingForMember) return 'card_pending_member';
  if (input.needsProfileOnboarding) return 'profile_onboarding';
  if (input.firmLocked) return 'locked';
  return 'app';
}
